export const usersUrl = 'users/';
